export const normalizeCustomizedItemQuantity = (value) => (
  Math.max(1, Math.trunc(Number(value) || 1))
);

export const customizedItemTotal = (unitPrice, quantity) => (
  Number(unitPrice || 0) * normalizeCustomizedItemQuantity(quantity)
);
